import NumberHumanizer from "@/util/NumberHumanizer"; 

export default NumberHumanizer;